import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Spin from 'antd/lib/spin';
import { 
  fetchExternalPendingTransactionsAction, 
  deleteExternalTransactionByIdAction,
  selectExternalTransaction, 
  selectExternalTransactionPagination, 
  selectExternalTransactionIsLoading,
} from '../ducks';
import { PendingTransactions } from '../components';

const mapStateToProps = state => ({
  pendingTransactions: selectExternalTransaction(state),
  pagination: selectExternalTransactionPagination(state),
  isLoading: selectExternalTransactionIsLoading(state),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchPendingTransactions: fetchExternalPendingTransactionsAction.request,
      deleteExternalTransactionById: deleteExternalTransactionByIdAction.request,
    },
    dispatch
  ),
});

@connect(mapStateToProps, mapDispatchToProps)
export default class PendingTransactionsContainer extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    pendingTransactions: PropTypes.array.isRequired,
    pagination: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
  };

  componentDidMount(){
    const { pagination } = this.props;
    this.props.actions.fetchPendingTransactions({pagination});
  }

  handleTableChange = (pagination) => {
    const { actions } = this.props;
    actions.fetchPendingTransactions({pagination});
  };

  handleDelete = (id) => {
    const { actions, pagination } = this.props;
    actions.deleteExternalTransactionById({id, pagination});
  }

  render() {

    const {
      pendingTransactions,
      pagination,
      isLoading,
    } = this.props;
    
    return (
      <Spin spinning={isLoading}>
        <PendingTransactions 
          transactions={pendingTransactions}
          pagination={pagination}
          onTableChange={this.handleTableChange}
          onDelete={this.handleDelete}
        />
      </Spin>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/transactions/containers/PendingTransactionsContainer.js